import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n      margin-bottom: 1rem;\n    "]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  justify-content: space-around;\n  margin: 0.5rem 0 0;\n\n  @media (min-width: ", ") {\n    flex-direction: row;\n    margin-bottom: 2rem;\n  }\n\n  @media (min-width: 1220px) {\n    justify-content: space-between;\n  }\n\n  .gallery {\n    width: 100%;\n\n    @media (min-width: ", ") {\n      width: 40%;\n    }\n\n    @media (min-width: 1220px) {\n      width: 490px;\n      height: 600px;\n    }\n\n    ", "\n\n    .slick-list {\n      border-radius: 10px;\n    }\n\n    .slick-track {\n      height: 500px;\n    }\n\n    .slick-slide {\n      > div {\n        height: 100%;\n        display: flex;\n        > img {\n          height: 100%;\n          width: auto !important;\n          margin: auto;\n          border-radius: 10px;\n        }\n      }\n    }\n\n    .slick-dots {\n      bottom: 1rem;\n    }\n\n    .prev-arrow {\n      position: absolute;\n      top: calc(50% - 14.75px);\n      left: 10px;\n      transform: translate(0, -40%);\n      width: 1rem;\n      display: block;\n      cursor: pointer;\n      z-index: 2;\n    }\n\n    .next-arrow {\n      position: absolute;\n      top: calc(50% - 14.75px);\n      right: 10px;\n      transform: translate(0, -40%) rotate(180deg);\n      width: 1rem;\n      display: block;\n      cursor: pointer;\n      z-index: 2;\n    }\n  }\n\n  .info {\n    width: 100%;\n    overflow: hidden;\n    position: relative;\n    padding: 1px;\n    margin-bottom: 1rem;\n    box-shadow: rgba(9, 30, 66, 0.13) 0px 0px 1px 1px;\n    border-radius: 10px;\n\n    @media (min-width: ", ") {\n      width: 40%;\n      aspect-ratio: 2/1;\n      margin-bottom: unset;\n    }\n\n    @media (min-width: 1220px) {\n      width: 490px;\n      height: 600px;\n      overflow: hidden;\n    }\n  }\n\n  .right {\n    width: 100%;\n\n    @media (min-width: ", ") {\n      width: 15%;\n    }\n\n    @media (min-width: 1220px) {\n      width: 200px;\n    }\n  }\n\n  .portal {\n    position: absolute;\n    top: 0;\n    left: 0;\n    border-radius: 10px;\n    overflow: hidden;\n  }\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  width: 1200px;\n  max-width: 100vw;\n  margin: 0 auto;\n  padding: 0;\n  margin-bottom: 2rem;\n\n  @media (max-width: 1219px) {\n    width: 100%;\n    padding: 0 10px;\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  background: white;\n  color: ", ";\n  font-weight: 600;\n  position: absolute;\n  width: calc(100% - 1rem);\n  margin: 0.5rem;\n  top: 0;\n  left: 0;\n  text-align: center;\n  animation-name: fadeOut;\n  animation-duration: 1s;\n  animation-fill-mode: both;\n  animation-delay: 10s;\n  font-size: 0.75rem;\n\n  p {\n    line-height: unset;\n    width: 100%;\n  }\n\n  ", " {\n    font-size: 0.875rem;\n  }\n\n  @keyframes fadeOut {\n    0% {\n      opacity: 1;\n    }\n    100% {\n      opacity: 0;\n      pointer-events: none;\n    }\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  width: 1200px;\n  max-width: 100vw;\n  margin: 0 auto;\n  padding: 0;\n  position: relative;\n\n  @media (max-width: 1219px) {\n    width: 100%;\n    padding: 0 10px;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import { styled, media } from "@styles";
export var Breadcrumbs = styled.div(_templateObject());
export var Hint = styled.div(_templateObject2(), function (props) {
  return props.theme.colors.blackGrayText;
}, function (props) {
  return props.theme.breakpoints.xxSmallScreen;
});
export var Container = styled.div(_templateObject3());
export var Wrapper = styled.div(_templateObject4(), function (props) {
  return props.theme.breakpoints.largeScreen;
}, function (props) {
  return props.theme.breakpoints.largeScreen;
}, media.largeScreen(_templateObject5()), function (props) {
  return props.theme.breakpoints.largeScreen;
}, function (props) {
  return props.theme.breakpoints.largeScreen;
});